import React from 'react';
import { processSteps } from '../../data/mock';
import '../../styles/landing.css';

const ProcessSection = () => {
  return (
    <section id="proceso" className="section section-dark">
      <div className="container">
        <div className="section-header">
          <div className="section-label">Proceso</div>
          <h2 className="heading-1 section-title" style={{ color: 'white' }}>
            ¿Cómo Funciona?
          </h2>
          <p className="body-large section-subtitle" style={{ color: '#D1D1D1' }}>
            Un proceso simple y eficiente, 100% online
          </p>
        </div>
        
        <div className="process-grid">
          {processSteps.map((step) => (
            <div key={step.step} className="process-step">
              <div className="process-number">{step.step}</div>
              <h4 className="heading-3">{step.title}</h4>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
